export enum PartnerType {
  CENSUS = 'CENSUS',
  DSR_MARKETING = 'DSR_MARKETING',
  SYNERGOS = 'SYNERGOS',
  TRAVEL_TIME = 'TRAVEL_TIME'
}
